import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { of, catchError, mergeMap } from 'rxjs'
import { initialize_failed, initialize_success, start_initializing } from '../action/initialize.action'
import { InitializeService } from 'src/app/services/initialize/initialize.service'

@Injectable()
export class InitializeEffects {
  constructor(private actions$: Actions, private initializeService: InitializeService) {}

  start_initialize$ = createEffect(() => {
    let comingFromLogin = false
    return this.actions$.pipe(
      ofType(start_initializing),
      mergeMap((action) => {
        comingFromLogin = action.comingFromLogin
        return this.initializeService
          .getInitialSettingsData()
          .pipe(catchError((error: any) => of(initialize_failed(error))))
      }),
      mergeMap((response) => [initialize_success({ initializeData: response, comingFromLogin })])
    )
  })
}
